<template>
  <span class="svg-ico-dot-4-grid">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.98234 10.1951C8.5335 10.1951 9.79085 8.93773 9.79085 7.38664C9.79085 5.83554 8.5335 4.57812 6.98234 4.57812C5.43118 4.57812 4.17383 5.83554 4.17383 7.38664C4.17383 8.93773 5.43118 10.1951 6.98234 10.1951Z" :fill="color"/>
      <path d="M6.98234 21.0781C8.5335 21.0781 9.79085 19.8207 9.79085 18.2696C9.79085 16.7185 8.5335 15.4611 6.98234 15.4611C5.43118 15.4611 4.17383 16.7185 4.17383 18.2696C4.17383 19.8207 5.43118 21.0781 6.98234 21.0781Z" :fill="color"/>
      <path d="M20.6738 7.38664C20.6738 8.93773 19.4165 10.1951 17.8653 10.1951C16.3142 10.1951 15.0568 8.93773 15.0568 7.38664C15.0568 5.83554 16.3142 4.57812 17.8653 4.57812C19.4165 4.57812 20.6738 5.83554 20.6738 7.38664Z" :fill="color"/>
      <path d="M17.8653 21.0781C19.4165 21.0781 20.6738 19.8207 20.6738 18.2696C20.6738 16.7185 19.4165 15.4611 17.8653 15.4611C16.3142 15.4611 15.0568 16.7185 15.0568 18.2696C15.0568 19.8207 16.3142 21.0781 17.8653 21.0781Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
